import { TypesContextesAutorisesEnum } from '@/features/auth/context-app'
import { MachineEtat } from '@/features/domaine/machine-etats'
import { useAppStateStore } from '@/features/application'
import type { FraisDTO } from '@/features/api/extranet/dto/Demande/DR'
import { AjouteFraisConfiguration } from '@/features/interface/demande/dr/ajouter-frais/AjouteFraisConfiguration.ts'
import type { AjouteFraisLaunch } from '@/features/interface/demande/dr/ajouter-frais/types.ts'

type UseAjouteFraisResult = {
  statut: 'OK'
  frais: FraisDTO[]
} | {
  statut: 'KO',
  error: string
}

export function useAjouteFrais() {
  const appState = useAppStateStore()
  async function showDialog(launchParams: AjouteFraisLaunch): Promise<UseAjouteFraisResult> {
    if (appState.contextCourant !== TypesContextesAutorisesEnum.Adherent)
      throw "La fonction useAppStateStore n'est utilisable que dans un contexte Adhérent"

    const engine = new MachineEtat(AjouteFraisConfiguration)

    try {
      const result = await engine.launch({
        titre: 'Ajouter des frais supplémentaires',
        contextCourant: TypesContextesAutorisesEnum.Adherent,
        launchParams,
      })

      return {
        statut: 'OK',
        frais: result.frais
      }
    } catch (error) {
      return {
        statut: 'KO',
        error: error instanceof Error ? error.message : `${error}`
      }
    }
  }

  return { showDialog }
}


